module.exports = __webpack_public_path__ + "static/media/6666.70c30af9.jpg";